var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"135f86c02bd05b2c3f95d0dd124463bb21a1c6b9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["help-center@klaviyo-1"]={id:"135f86c02bd05b2c3f95d0dd124463bb21a1c6b9"};
      